import { render } from "./addOrTransferOrDeparture.vue?vue&type=template&id=bc24144e"
import script from "./addOrTransferOrDeparture.vue?vue&type=script&lang=js"
export * from "./addOrTransferOrDeparture.vue?vue&type=script&lang=js"

import "./addOrTransferOrDeparture.vue?vue&type=style&index=0&id=bc24144e&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__